// posts
export const FETCH_ALL = 'FETCH_ALL';
export const CREATE = 'CREATE';
export const UPDATE = 'UPDATE';
export const LIKE = 'LIKE';
export const DELETE = 'DELETE';

// auth
export const AUTH = 'AUTH';
export const LOGOUT = 'LOGOUT';
// Using constants will prevent the hidden error of miss spelling a string so we put them in a variable . when miss spelling a variable you will get an error

//users
export const FETCH_U_ALL = 'FETCH_U_ALL';
export const DELETE_USER = 'DELETE_USER';
export const BLOCK_USER = 'BLOCK_USER';